(() => {
 'use strict';
 if (window.__PW_WISE_CREDIT_V2__) return;
 window.__PW_WISE_CREDIT_V2__ = true;
 const ROOT = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
 const PROXY = `${ROOT}apps/wise-club/wise-credit`;
 const shared = window.__PW_CART_DATA__ ||= { value: null, at: 0, pending: null, generation: 0 };
 let boot = {}; try { boot = JSON.parse(document.querySelector('[data-pw-wise-credit-config]')?.textContent || '{}'); } catch {}
 let cart = shared.value || boot.cart || { item_count: boot.itemCount || 0, total_price: boot.totalPriceMinor || 0, currency: 'GBP' };
 let state = null, checkedAt = 0, busy = false, loading = null, timer, expiryTimer, notice = '', noticeError = false;
 let dirty = false, wantedAmount = null, requestKey = null, cartSyncFailed = false, operationPending = false;
 const money = (n) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: cart.currency || 'GBP' }).format(Number(n || 0) / 100);
 const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
 const key = () => String(cart.token || '').split('?')[0];
 const isWise = (code) => /^WISE-[A-F0-9]{10,32}$/i.test(String(code || ''));
 const codeFrom = (entry) => {
  const a = entry?.discount_application || entry;
  return a?.code || String(a?.title || '').match(/WISE-[A-F0-9]{10,32}/i)?.[0] || '';
 };
 // Shopify POST /cart/update.js returns allocation wrappers, whereas GET
 // /cart.js returns flat applications. Normalize BOTH before any comparison.
 function cartApplications() {
  return (cart.cart_level_discount_applications || []).map((entry) => {
   const a = entry?.discount_application || entry || {};
   const raw = entry?.amount ?? entry?.total_allocated_amount ?? a.total_allocated_amount ?? 0;
   const amount = Number(raw);
   return { ...a, total_allocated_amount: Number.isSafeInteger(amount) && amount >= 0 ? amount : 0 };
  });
 }
 const active = () => Boolean(state?.ok && state.reservation?.status === 'ACTIVE' && state.reservation.discountCode && Date.parse(state.reservation.expiresAt) > Date.now());
 const activeCode = () => active() ? state.reservation.discountCode : '';
 const actualWise = () => cartApplications().filter((a) => isWise(codeFrom(a))).reduce((sum, a) => sum + a.total_allocated_amount, 0);
 const currentCodes = () => [...new Set([
  ...(cart.discount_codes || []).map((c) => typeof c === 'string' ? c : c.code),
  ...cartApplications().filter((a) => a.type === 'discount_code').map((a) => codeFrom(a) || a.title),
  ...(cart.items || []).flatMap((i) => (i.line_level_discount_allocations || []).filter((a) => a.discount_application?.type === 'discount_code').map((a) => a.discount_application.code || a.discount_application.title)),
 ].filter(Boolean))];
 const hasWise = () => currentCodes().some(isWise) || actualWise() > 0;
 const amountApplied = () => active() ? cartApplications().filter((a) => codeFrom(a).toUpperCase() === activeCode().toUpperCase()).reduce((sum, a) => sum + a.total_allocated_amount, 0) : 0;
 const maximum = () => Math.max(0, Math.min(Number(state?.redeemableCreditMinor ?? state?.availableCreditMinor ?? 0), Math.floor((Number(cart.total_price || 0) + actualWise()) * Number(state?.maximumRedemptionPercent || 100) / 100)));
 const cacheName = () => `pw-wise-credit:v2:${boot.customerId || 'guest'}:${key()}`;
 function cache(write = false) {
  try {
   if (write) { sessionStorage.setItem(cacheName(), JSON.stringify({ state, at: Date.now() })); return; }
   const saved = JSON.parse(sessionStorage.getItem(cacheName()) || 'null');
   if (boot.authenticated && boot.customerId && saved && Date.now() - saved.at < 180000 && saved.state?.authenticated === true) return saved.state;
  } catch {}
  return null;
 }
 async function json(url, options = {}, timeout = 45000) {
  const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options,
   headers: { Accept: 'application/json', ...(options.headers || {}) }, signal: AbortSignal.timeout(timeout) });
  const data = await response.json().catch(() => null);
  if (!response.ok || !data) throw new Error(data?.error || data?.description || `Request failed (${response.status}). Please retry.`);
  return data;
 }
 function adopt(next, announce = false) {
  // /cart/add.js may return items without cart totals. Never treat that as a full cart.
  if (!next || !Array.isArray(next.items) || !Number.isFinite(Number(next.total_price)) || !next.token) return;
  cart = next; shared.value = next; shared.at = Date.now(); shared.generation++;
  if (announce) document.dispatchEvent(new CustomEvent('pw:cart:state', { detail: { cart: next, source: 'wise-credit' } }));
 }
 async function getCart(force = false) {
  if (shared.pending) { adopt(await shared.pending); return cart; }
  // force means a real network read, not the just-written POST response.
  if (shared.value && !force) { adopt(shared.value); return cart; }
  const generation = shared.generation;
  shared.pending = json(`${ROOT}cart.js`, {}, 15000).then((next) => {
   if (shared.generation === generation || !shared.value) adopt(next);
   return shared.value;
  }).finally(() => { shared.pending = null; });
  adopt(await shared.pending); return cart;
 }
 async function proxy(body) {
  const data = await json(body ? PROXY : `${PROXY}?cart_token=${encodeURIComponent(key())}`,
   body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...body, cartToken: key() }) } : {});
  if (data.app !== 'wise-club' || !data.ok) throw new Error(data.error || 'Wise Credit could not be verified.');
  return data;
 }
 function accept(data) {
  state = data; checkedAt = Date.now(); cache(true); clearTimeout(expiryTimer);
  if (active()) expiryTimer = setTimeout(() => refresh(true), Math.max(500, Date.parse(state.reservation.expiresAt) - Date.now() + 250));
 }
 function targets() {
  const drawerTargets = Array.from(document.querySelectorAll('header-cart-drawer .cart__footer'), (host) => {
   const drawer = host.closest('header-cart-drawer');
   const walletHost = drawer?.querySelector('[data-pw-cart-wallet-slot]') || null;
   return walletHost ? { host, walletHost, kind: 'drawer' } : null;
  }).filter(Boolean);
  const pageTargets = Array.from(document.querySelectorAll('#CartPageForm .cart__page-col.medium-up--overlay'), (host) => ({ host, walletHost: host.querySelector('[data-pw-page-wallet-slot]') || host, kind: 'page' }));
  return [...drawerTargets, ...pageTargets];
 }
 function paintSummary(host) {
  const existing = host.querySelector('.cart__item--subtotal'), discounts = host.querySelector('[data-discounts]');
  if (!existing) return;
  let summary = host.querySelector('[data-wise-cart-summary]');
  if (!summary) { summary = document.createElement('div'); summary.dataset.wiseCartSummary = ''; summary.className = 'pww-summary'; existing.before(summary); }
  if (!Array.isArray(cart.items)) { summary.hidden = true; return; }
  summary.hidden = false; existing.hidden = true; existing.setAttribute('data-wise-replaced', '');
  if (discounts) { discounts.hidden = true; discounts.setAttribute('data-wise-replaced', ''); }

  const apps = cartApplications();
  const totalDiscount = apps.reduce((n, a) => n + a.total_allocated_amount, 0);
  const shopifyNet = Math.max(0, Number(cart.total_price || 0));
  const originalItems = (cart.items || []).reduce((sum, item) => sum + Math.max(0, Number(item.original_line_price ?? (Number(item.original_price || item.price || 0) * Number(item.quantity || 0)))), 0);
  const projection = typeof window.PWBmsmCartProjection === 'function' ? window.PWBmsmCartProjection(cart) : { savings: 0 };
  const pendingSavings = Math.max(0, Number(projection.savings || 0));
  const itemSubtotal = originalItems || Number(cart.items_subtotal_price ?? (shopifyNet + totalDiscount));
  const actualProductSavings = Math.max(0, itemSubtotal - shopifyNet - totalDiscount);
  const netItems = Math.max(0, shopifyNet - pendingSavings);
  const freeShippingThreshold = Number(document.body?.dataset?.pwFreeShippingThreshold || 10000);
  const ukExpressShipping = Number(document.body?.dataset?.pwStandardShipping || 899);
  const hasFreeWipes = cart.items.some(item => item.properties?._pw_free_wipes_gift === 'true' && Number(item.final_line_price) === 0);
  const shippingEligibleSubtotal = hasFreeWipes ? netItems : Math.max(itemSubtotal, netItems + totalDiscount);
  const shipping = cart.requires_shipping !== false && netItems > 0 && shippingEligibleSubtotal < freeShippingThreshold ? ukExpressShipping : 0;
  const vatRate = Math.max(0, Number(document.body?.dataset?.pwVatRate || 20)) / 100;
  const taxesIncluded = document.body?.dataset?.pwTaxesIncluded === 'true';
  const taxableTotal = Math.max(0, netItems + shipping);
  const vat = vatRate > 0 ? Math.round(taxesIncluded ? taxableTotal * vatRate / (1 + vatRate) : taxableTotal * vatRate) : 0;
  const grandTotal = taxesIncluded ? taxableTotal : taxableTotal + vat;

  let html = `<div class="pww-summary__items"><strong>Items subtotal</strong><strong>${money(itemSubtotal)}</strong></div>`;
  if (actualProductSavings > 0) html += `<div class="pww-summary__saving"><span>Product discounts applied</span><strong>&minus;${money(actualProductSavings)}</strong></div>`;
  for (const a of apps) {
   const amount = a.total_allocated_amount; if (amount <= 0) continue;
   html += `<div class="pww-summary__saving"><span>${isWise(codeFrom(a)) ? 'Wise Credit applied' : esc(a.title || 'Discount')}</span><strong>&minus;${money(amount)}</strong></div>`;
  }
  if (pendingSavings > 0) html += `<div class="pww-summary__saving"><span>Buy More Save More (estimated at checkout)</span><strong>&minus;${money(pendingSavings)}</strong></div>`;
  if (totalDiscount + actualProductSavings + pendingSavings > 0) html += `<div class="pww-summary__net"><span>${pendingSavings ? 'Estimated subtotal' : 'Subtotal after discounts'}</span><strong>${money(netItems)}</strong></div>`;
  if (vatRate > 0) html += `<div class="pww-summary__vat"><span>VAT (${Math.round(vatRate * 100)}%)</span><strong>${money(vat)}</strong></div>`;
  if (shipping > 0) html += `<div class="pww-summary__shipping"><span>Shipping (UK Express est.)</span><strong>${money(shipping)}</strong></div>`;
  html += `<div class="pww-summary__grand"><strong>${pendingSavings ? 'Estimated Grand Total' : 'Grand Total'}</strong><strong>${money(grandTotal)}</strong></div>`;
  if (pendingSavings > 0) html += '<small style="display:block;margin-top:6px;color:#66736b">Estimated savings. Final discounts and VAT are confirmed at checkout.</small>';
  if (summary.__html !== html) { summary.innerHTML = html; summary.__html = html; }
 }
 const emblem = 'https://cdn.shopify.com/s/files/1/0803/2459/1905/files/wise-club-credit-emblem.png?v=1789469663&width=240';
 function inputs() {
  const max = maximum(), min = Number(state?.minimumRedemptionMinor || 100);
  const selected = Math.min(max, wantedAmount ?? max);
  return `<div class="pww-controls"><label><span class="pww-sr-only">Amount of Wise Credit in pounds</span><span aria-hidden="true">&pound;</span><input aria-label="Wise Credit amount in pounds" data-wise-amount type="number" inputmode="decimal" min="${min / 100}" max="${max / 100}" step="0.01" value="${(selected / 100).toFixed(2)}"></label><button type="button" data-wise-max>Use max</button><button type="button" class="pww-apply" data-wise-apply>Apply <span data-wise-amount-label>${money(selected)}</span></button></div>`;
 }
 const isGuest = () => state?.authenticated === false || (!boot.authenticated && !state);
 function markup(kind) {
  const verified = checkedAt > 0 && state?.ok;
  const remainingRaw = Number(state?.remainingCreditMinor ?? state?.availableCreditMinor ?? boot.availableCreditMinor ?? 0);
  const remaining = isGuest() ? 0 : remainingRaw;
  const applied = amountApplied();
  const label = active() ? 'Remaining Wise Credit' : 'Available Wise Credit';
  const statusText = isGuest() ? 'Sign in or create an account to use Wise Credit' : active() && applied > 0 ? 'In your Wise Club wallet' : !verified ? 'Checking balance...' : 'Use your rewards on this order';
  const test = boot.preview && state?.mode === 'TEST' ? '<span class="pww-test">TEST</span>' : '';
  let html = '';
  if (kind === 'drawer') {
   // Direct, compact controls: no toggle/re-render before the customer can type.
    if (isGuest()) {
     return `<div class="pww-guest-strip"><img src="${emblem}" alt="" width="22" height="22"><div class="pww-guest-strip__copy"><strong>Wise Credit</strong><span>Create an account to use credit & unlock member benefits.</span><a class="pww-signin-link" href="${ROOT}account/login?return_url=${encodeURIComponent(ROOT+'cart')}">Already a member? <b>Sign in</b></a></div><a class="pww-create-account" href="${ROOT}account/register">Create account</a></div>`;
    }
    html = `<div class="pww-mini"><img src="${emblem}" alt="" width="28" height="28"><div><strong>Wise Credit <span>${money(remaining)}</span></strong><small>${active() && applied > 0 ? `${money(applied)} applied &middot; ${money(remaining)} remaining` : verified ? 'Available balance' : 'Checking balance...'}</small></div>${active() ? '<button type="button" data-wise-remove>Remove</button>' : ''}</div>`;
  } else {
   if (isGuest()) {
    return `<div class="pww-guest-strip"><img src="${emblem}" alt="" width="22" height="22"><div class="pww-guest-strip__copy"><strong>Wise Credit</strong><span>Create an account to use credit & unlock member benefits.</span><a class="pww-signin-link" href="${ROOT}account/login?return_url=${encodeURIComponent(ROOT+'cart')}">Already a member? <b>Sign in</b></a></div><a class="pww-create-account" href="${ROOT}account/register">Create account</a></div>`;
   }
   html = `<div class="pww-hero"><img src="${emblem}" alt="" width="144" height="144"><div><span>${label}</span><strong>${money(remaining)}</strong><small>${statusText}</small></div>${test}</div>`;
  }
  let body = '';
  if (isGuest()) body = `<div class="pww-guest-compact"><p>You need an account to use Wise Credit. Create an account so you don’t miss the benefits.</p><a class="pww-create-account" href="${ROOT}account/register">Create account</a><a class="pww-signin-link" href="${ROOT}account/login?return_url=${encodeURIComponent(ROOT+'cart')}">Already have an account? <strong>Sign in</strong></a></div>`;
  else if (!verified) body = `<div class="pww-wait">${noticeError ? 'Could not verify your balance.' : 'Checking your Wise Credit...'}</div>${noticeError ? '<button type="button" data-wise-retry>Retry</button>' : ''}`;
  else if (!state.enabled || (cart.currency && cart.currency !== state.currency)) body = '<small>Wise Credit is not available for this cart.</small>';
  else if (active()) {
   if (kind === 'page') body = `<div class="pww-applied"><span><b>${money(applied || state.reservation.amountMinor)} ${applied ? 'applied' : 'reserved'}</b><small>Discount on this order</small></span><button type="button" data-wise-remove>Remove</button></div>`;
  } else if (maximum() < Number(state.minimumRedemptionMinor || 100)) body = '<small>'+ (remaining > 0 ? `Minimum use is ${money(state.minimumRedemptionMinor || 100)}.` : 'Earn Wise Credit on eligible purchases.') + '</small>';
  else body = inputs();
  if (body) html += `<div class="pww-body">${body}</div>`;
  if (notice) html += `<div class="pww-notice${noticeError ? ' is-error' : ''}" role="status" aria-live="polite">${esc(notice)}${noticeError ? ' <button type="button" data-wise-retry>Retry</button>' : ''}</div>`;
  return html;
 }
 function render() {
  for (const {host,walletHost,kind} of targets()) {
   paintSummary(host);
   const searchRoot = kind === 'drawer' ? host.closest('header-cart-drawer') : walletHost;
   let panel = searchRoot?.querySelector(`[data-wise-credit-cart="${kind}"]`) || null;
   if (!Number(cart.item_count || 0)) { panel?.remove(); continue; }
   if (!panel) {
    panel = document.createElement('section'); panel.className = `pw-wise-credit-card pww-wallet pww-wallet--${kind}`;
    panel.dataset.wiseCreditCart = kind; panel.setAttribute('aria-label','Wise Credit');
   }
   if (kind === 'drawer') {
    if (panel.parentElement !== walletHost) walletHost.append(panel);
   } else {
    if (panel.parentElement !== walletHost) walletHost.append(panel);
   }
   const html = markup(kind);
   if (panel.__html !== html) { panel.innerHTML = html; panel.__html = html; }
   panel.classList.toggle('pww-wallet--guest', isGuest());
   panel.setAttribute('aria-busy', String(busy));
   panel.querySelectorAll('button,input').forEach((el) => { el.disabled = busy || (!checkedAt && !el.matches('[data-wise-retry]')); });
  }
  document.querySelectorAll('#CartPageForm .additional-checkout-buttons,header-cart-drawer .additional-checkout-buttons').forEach((el) => {
   if (active() || hasWise() || busy) { if (!el.hasAttribute('data-wise-old-hidden')) el.dataset.wiseOldHidden = String(el.hidden); el.hidden = true; }
   else if (el.hasAttribute('data-wise-old-hidden')) { el.hidden = el.dataset.wiseOldHidden === 'true'; delete el.dataset.wiseOldHidden; }
  });
 }
 async function writeDiscount(code) {
  const other = currentCodes().filter((c) => !isWise(c));
  const discount = [...new Set([...other, ...(code ? [code] : [])])].join(',');
  const next = await json(`${ROOT}cart/update.js`, { method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({ discount, sections:['cart-ajax'], sections_url: `${ROOT}cart` }) }, 20000);
  adopt(next, true);
  const markup = next.sections?.['cart-ajax'];
  if (markup) {
   document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles:true, detail:{ product:next, preventCartOpen:true, wiseCredit:true } }));
   const doc = new DOMParser().parseFromString(markup,'text/html');
   const products = doc.querySelector('.cart__items');
   const host = document.querySelector('#CartPageForm [data-products]');
   if (products && host && !document.body.classList.contains('template-cart')) host.replaceChildren(products);
  }
  cartSyncFailed = false; render(); return next;
 }
 async function releaseCredit() {
  const codes = currentCodes().filter(isWise); if (activeCode()) codes.push(activeCode());
  accept(await proxy({action:'release',codes:[...new Set(codes)]}));
  try { await writeDiscount(''); }
  catch (error) { cartSyncFailed = true; throw new Error('Credit is safe, but the cart could not refresh. Retry before checkout.'); }
  if (hasWise()) { cartSyncFailed = true; throw new Error('The cart still shows Wise Credit. Retry before checkout.'); }
 }
 async function reconcile() {
  if (!state?.ok) return;
  if (!active() && hasWise()) { await writeDiscount(''); return; }
  if (!active()) return;
  const amount = amountApplied();
  if (cart.item_count && amount===0 && Date.now()-Date.parse(state.reservation.createdAt || 0)<8000) {
   schedule(8500,true); return;
  }
  if (!cart.item_count || amount !== Number(state.reservation.amountMinor)) {
   await releaseCredit(); notice = 'Wise Credit was removed because the cart or discount changed.';
  }
 }
 async function refresh(force = false) {
  if (busy) { dirty = true; return; }
  if (loading) return loading;
  dirty=false;
  if (!force && checkedAt && Date.now()-checkedAt<3000) { render(); return; }
  loading = (async () => {
   try {
    await getCart(force);
    if (!key()) { render(); return; }
    if (!state) state=cache();
    render();
    accept(await proxy());
    busy = true;
    await reconcile();
    if (cartSyncFailed && !active()) await writeDiscount('');
    noticeError = false;
   } catch(error) { notice = error.message || 'Wise Credit could not be verified. Please retry.'; noticeError = true; checkedAt = 0; }
   finally { busy = false; loading = null; render(); }
  })();
  return loading;
 }
 async function change(remove = false) {
  if (busy || operationPending) return;
  operationPending=true;
  try {
   if (loading) await loading;
   busy=true; notice=''; noticeError=false; render();
   await getCart(true);
   if (remove) {
    await releaseCredit(); wantedAmount=null; requestKey=null; notice='Wise Credit removed.';
   } else {
    const amount = wantedAmount ?? maximum();
    if (!Number.isSafeInteger(amount) || amount<=0) throw new Error('Enter a valid Wise Credit amount.');
    requestKey ||= crypto.randomUUID();
    accept(await proxy({ action:'redeem', amountMinor:amount, cartTotalMinor:Number(cart.total_price||0)+actualWise(),currency:cart.currency||'GBP',idempotencyKey:requestKey }));
    if (!active()) throw new Error('Wise Credit reservation was not confirmed.');
    try {
     await writeDiscount(activeCode());
     if (amountApplied()!==Number(state.reservation.amountMinor)) await getCart(true);
     if (amountApplied()!==Number(state.reservation.amountMinor)) throw new Error('Shopify has not applied the selected Wise Credit. Your balance will be restored; please retry.');
    } catch (error) {
     await releaseCredit(); throw error;
    }
    requestKey=null; notice='';
   }
  } catch(error) { notice=error.message || 'Wise Credit could not be updated.'; noticeError=true; requestKey=null; }
  finally { operationPending=false; busy=false; render(); if(dirty){dirty=false; schedule(150,true);} }
 }
 async function checkout(form) {
  if(operationPending) return;
  operationPending=true;
  try {
   if(loading) await loading;
   busy=true; notice=''; render();
   const terms=form.querySelector('input[name="CartTerms"]');
   if(terms && !terms.checked) throw new Error('Please agree to the terms and conditions.');
   await getCart(true);
   accept(await proxy());
   if (cartSyncFailed) throw new Error('Please retry the cart refresh before checkout.');
   const hadCredit=active()||hasWise();
   await reconcile();
   if(hadCredit && !active()) throw new Error('Wise Credit changed. Please review your updated cart before checkout.');
   if(active() && (!state.enabled || amountApplied()!==Number(state.reservation.amountMinor))) throw new Error('Wise Credit is not fully applied. Please remove and apply it again.');
   window.location.assign(`${ROOT}checkout`);
  } catch(error) { notice=error.message; noticeError=true; }
  finally { operationPending=false; busy=false; render(); }
 }
 function requiresCreditCheckout() {
  return active() || hasWise() || cartSyncFailed || operationPending || (!Array.isArray(cart.items) && Boolean(loading || busy));
 }
 function schedule(delay=120,force=false){clearTimeout(timer);timer=setTimeout(()=>refresh(force),delay);}
 document.addEventListener('input',(e)=>{
  if(!e.target.matches?.('[data-wise-amount]'))return;
  wantedAmount=Math.round(Number(e.target.value)*100);
  document.querySelectorAll('[data-wise-amount-label]').forEach(el=>{el.textContent=Number.isFinite(wantedAmount)?money(wantedAmount):'';});
 });
 document.addEventListener('click',(e)=>{
  const el=e.target.closest?.('button,a,input'); if(!el || el.disabled)return;
  // Buttons may replace their own DOM nodes. Do not let that click reach the
  // header's outside-click handler after its target has become detached.
  if(el.closest('[data-wise-credit-cart]')) e.stopPropagation();
  if(el.matches('[data-wise-retry]')){e.preventDefault();e.stopImmediatePropagation();notice='';refresh(true);return;}
  if(el.matches('[data-wise-max]')){
   e.preventDefault();e.stopImmediatePropagation();wantedAmount=maximum();
   document.querySelectorAll('[data-wise-amount]').forEach(i=>i.value=(wantedAmount/100).toFixed(2));
   document.querySelectorAll('[data-wise-amount-label]').forEach(i=>i.textContent=money(wantedAmount));return;
  }
  if(el.matches('[data-wise-apply],[data-wise-remove]')){e.preventDefault();e.stopImmediatePropagation();change(el.matches('[data-wise-remove]'));return;}
  if(el.matches('[name="checkout"],.cart__checkout') && el.closest('#CartPageForm,.cart__drawer-form') && requiresCreditCheckout()) {
   e.preventDefault();e.stopImmediatePropagation();checkout(el.closest('form'));
  }
 },true);
 document.addEventListener('submit',(e)=>{
  if(!e.target.matches?.('#CartPageForm,.cart__drawer-form'))return;
  if(document.activeElement?.matches('[data-wise-amount]')){e.preventDefault();e.stopImmediatePropagation();change();return;}
  if(e.submitter && e.submitter.name!=='checkout')return;
  if(requiresCreditCheckout()){e.preventDefault();e.stopImmediatePropagation();checkout(e.target);}
 },true);
 document.addEventListener('pw:cart:rendered',()=>{if(Array.isArray(cart.items)) render();});
 document.addEventListener('pw:cart:state',(e)=>{if(e.detail?.source==='wise-credit')return;adopt(e.detail?.cart);schedule(120,true);});
 for(const name of ['ajaxProduct:added','product-form:cart:update','cart:updated','cart:refresh'])document.addEventListener(name,(e)=>{
  if(e.detail?.wiseCredit)return;
  const next=e.detail?.cart || (Array.isArray(e.detail?.product?.items)?e.detail.product:null);
  if(next)adopt(next);
  dirty=true;schedule(160,true);
 });
 document.addEventListener('cart:open',()=>{render();schedule(0,Date.now()-checkedAt>5000);});
 document.addEventListener('change',(e)=>{if(!e.target.closest?.('[data-wise-credit-cart]')&&e.target.closest?.('#CartPageForm,header-cart-drawer')&&e.target.matches('input[type="number"],select'))schedule(350,true);});
 window.addEventListener('pageshow',(e)=>{if(e.persisted){checkedAt=0;schedule(0,true);}});
 document.addEventListener('visibilitychange',()=>{if(!document.hidden&&(active()||hasWise()||document.querySelector('#CartPageForm')))schedule(50,true);});
 function init(){
  if(document.querySelector('#CartPageForm'))refresh(true);
  else render();
  let renderPending=false;
  new MutationObserver((records)=>{
   if(renderPending || records.every(r=>r.target.closest?.('[data-wise-credit-cart],[data-wise-cart-summary]')))return;
   const relevant=records.some(r=>r.target.closest?.('#CartPageForm,header-cart-drawer') || Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches?.('#CartPageForm,header-cart-drawer')||n.querySelector?.('#CartPageForm,header-cart-drawer'))));
   if(relevant){renderPending=true;requestAnimationFrame(()=>{renderPending=false;render();});}
  }).observe(document.body,{childList:true,subtree:true});
 }
 window.PWWiseCredit={version:'3.0.0',refresh:()=>refresh(true)};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

